<template>
  <div class="col-lg-12 col-md-12 col-sm-12 mt-5">
    <b-card no-body>
      <b-card-header class="border-0">
        <h3 class="mb-0">Listado de cuentas</h3>
      </b-card-header>
      <el-table v-if="tableData.length" class="table-responsive table"
                header-row-class-name="thead-light"
                :data="tableData"
      >
        <el-table-column label="Nombre"
                         min-width="170px"
                         prop="userId">
          <template v-slot="{row}">
            {{ row.userId.name }}
          </template>
        </el-table-column>
        <el-table-column label="Banco"
                         prop="bank"
                         min-width="300px">
        </el-table-column>

        <el-table-column label="Tipo"
                         min-width="200px"
                         prop="type">
        </el-table-column>
        <el-table-column label="Numero"
                         min-width="200px"
                         prop="numberAccount">
        </el-table-column>
        <el-table-column label="Estado" prop="status" min-width="200px">
          <template v-slot="{row}">
            {{ row.status|status }}
          </template>
        </el-table-column>
        <el-table-column label="Fecha registro" prop="created_at" min-width="200px">
          <template v-slot="{row}">
            {{ row.created_at|formatDate }}
          </template>
        </el-table-column>
                <el-table-column label="Opciones" min-width="200px">
                  <template v-slot="{row}">
                    <button class="btn btn-sm btn-outline-primary" @click="openModal(row._id)">
                      <i class="ni ni-send"></i>
                    </button>
                    <button class="btn btn-sm btn-outline-primary" @click="deleteAccount(row._id)">
                      <i class="ni ni-fat-remove"></i>
                    </button>
                  </template>
                </el-table-column>
      </el-table>
      <b-card-footer class="py-4 d-flex justify-content-end">
        <base-pagination v-model="currentPage" :per-page="20" :total="total"></base-pagination>
      </b-card-footer>
    </b-card>

    <b-modal id="modal_update_status" hide-header hide-footer v-if="account_selected">
      <select name="" id="" v-model="account_selected.status" class="form-control">
        <option :value="true">Activo</option>
        <option :value="false">Inactivo</option>
      </select>
      <b-row class="form-group mt-2">
        <b-col>
          <b-form-file @change="setImage"/>
        </b-col>
      </b-row>
      <button class="btn btn-dark btn-block mt-2" @click="updateStatus">
          ACTUALIZAR ESTADO
      </button>
    </b-modal>
  </div>
</template>

<script>
import {get} from "@/util/axiosRequest";
import {Table, TableColumn} from "element-ui";
import uploadFile from "../../../util/uploadFile";
import {post} from "../../../util/axiosRequest";

export default {
  name: "Accounts",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data: () => ({
    transaction: {
      orderNumber: null,
      dateTransaction: null,
      description: null,
      amount: null,
      discount: null,
      balance: 0
    },
    tableData: [],
    currentPage: 1,
    total: 0,
    account_selected: null,
  }),

  mounted() {
    this.getAccounts()
  },

  methods: {
    getAccounts() {
      get("accounts", this.$route.params.id, true).then(({data}) => {
        this.tableData = data
      })
    },
    openModal(id){
      const model = this.tableData.find(x => x._id === id)
      this.account_selected = JSON.parse(JSON.stringify(model))
      this.$bvModal.show("modal_update_status")
    },
    async updateStatus(){
      if(this.account_selected.file){
        const obj = {id: this.account_selected._id, status: this.account_selected.status, file: this.account_selected.file}
        await uploadFile.upload(
          "accounts/update",
          obj
        );
        this.account_selected = null
        this.getAccounts()
        this.showMessage("Informacion actualizada correctamente", "success")
        location.reload()
      }else{
        this.showMessage("La imagen es requerida", "error")
      }
    },
    setImage(e){
      this.account_selected.file = e.target.files[0];
    },
    showMessage(message, type = 'success') {
      this.$swal({
        html: message,
        icon: (type === "success") ? 'success' : 'error',
        showCloseButton: false,
        showConfirmButton: false,
        show: false,
        timer: 2000
      });
    },
    deleteAccount(id){
      this.$swal({
        title: 'Esta seguro?',
        icon: 'question',
        showCancelButton: true,
        showConfirmButtom: true,
        confirmButtonColor: '#191c4d',
        cancelButtonColor: '#191c4d',
        confirmButtonText: 'Si',
        cancelButtonText: 'No'
      }).then(async ({isConfirmed}) => {
        if (isConfirmed) {
          await post(`accounts/delete`, {_id: id}, true)
          this.getAccounts()
          this.showMessage("Cuenta eliminada correctamente", "success")
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
